import React from "react";

const FeaturedServices = () => {
  // Data structure for easy management
  const servicesData = [
    {
      title: "Cloud & DevOps",
      desc: "Reliable deployments, CI/CD pipelines and infrastructure automation for seamless scaling.",
      // Eye/Server Icon
      iconPath:
        "M12 8c-1.657 0-3 1.567-3 3.5S10.343 15 12 15s3-1.567 3-3.5S13.657 8 12 8z M19.428 15.341A8 8 0 116.66 4.572",
    },
    {
      title: "Full-stack Engineering",
      desc: "End-to-end development from APIs and robust databases to polished frontend experiences.",
      // List/Menu Icon
      iconPath: "M3 7h18M3 12h18M3 17h18",
    },
    {
      title: "E-commerce Solutions",
      desc: "Secure payment integrations and storefronts optimized for conversion and user experience.",
      // Chart/Activity Icon
      iconPath: "M3 10h4l3 8 4-16 3 8h4",
    },
  ];

  return (
    // Section Container: Slate-50 for contrast with white site
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">
            Our Specialized Services
          </h2>
          <p className="text-lg text-slate-600">
            We focus on three core pillars to ensure your digital transformation
            is successful and sustainable.
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <div
              key={index}
              // Card Styling: White bg, border, shadow, and hover lift effect
              className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start gap-4">
                {/* Icon Container: Changes color on hover */}
                <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center transition-all duration-300 group-hover:bg-blue-600 group-hover:text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-7 h-7"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d={service.iconPath} />
                  </svg>
                </div>

                {/* Text Content */}
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-sm">
                    {service.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedServices;
